// extracted by mini-css-extract-plugin
export var content_wrapper = "styles-module--content_wrapper--f7564";
export var hr_dark_bg = "styles-module--hr_dark_bg--5215b";
export var hr_light_bg = "styles-module--hr_light_bg--537ef";
export var newH4 = "styles-module--newH4--ba4f7";
export var row = "styles-module--row--bd460";
export var text_dark = "styles-module--text_dark--98987";
export var text_light = "styles-module--text_light--d6c67";